export function calculateDamageMultiplier(resistance) {
  if (resistance >= 0) {
    return 100 / (100 + resistance);
  }
  return 2 - (100 / (100 - resistance));
}

export function calculateDamageReduction(resistance) {
  if (resistance <= 0) return 0;
  return (resistance / (100 + resistance)) * 100;
}

export function calculateFinalDamage({ rawDamage, isCrit = false, ieEquipped = false, targetArmor = 0 }) {
  let damage = rawDamage;

  if (isCrit) {
    const critMultiplier = ieEquipped ? 2.5 : 2.0;
    damage *= critMultiplier;
  }

  const multiplier = calculateDamageMultiplier(targetArmor);
  return damage * multiplier;
}
